import copy from 'copy-to-clipboard';

export const copyForPast = (value: string) => {
  copy(value);
};
